// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"b8b7a97e","787":"11669714"}[chunkId] + ".chunk.js";
};